export const EVENT_START = new Date('2022-08-01T00:00:00')
export const EVENT_FIRST_STEP_DAYS = 15
export const EVENT_SECOND_STEP_DAYS = 10
export const EVENT_THIRD_STEP_DAYS = 6
export const EVENT_END = new Date('2022-09-01T00:00:00')
